import type {
  LinkableDeliveryNotesQueryParams,
  LinkableDeliveryNotesResponse,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  zodLinkableDeliveryNotesQueryParamsSchema,
  zodLinkableDeliveryNotesResponseSchema,
} from './validations';

/**
 * Fetches one page of the delivery notes that can be linked to the invoice.
 *
 * @param queryParams - The invoice id plus search, filter and paging params; empty params are not sent.
 * @param options - Optional request options, such as an abort signal.
 * @returns One page of linkable delivery notes.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices
 */
export async function fetchLinkableDeliveryNotes(
  { invoiceId, ...queryParams }: LinkableDeliveryNotesQueryParams,
  options?: KyRequestOptions,
): Promise<LinkableDeliveryNotesResponse> {
  return vestigasApi
    .get(ENDPOINT.INVOICE.GET_LINKABLE_DELIVERY_NOTES(invoiceId), {
      searchParams: queryParams,
      ...options,
      validate: {
        ...options?.validate,
        response: zodLinkableDeliveryNotesResponseSchema,
        searchParams: zodLinkableDeliveryNotesQueryParamsSchema.transform(
          (data) => withoutObjectKeysWhereValueIs(data, [undefined, '']),
        ),
      },
    })
    .json<LinkableDeliveryNotesResponse>();
}
